var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.256,
    height: 10.497
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "medium close",
    d: "M.002 9.435L4.19 5.249.003 1.062 1.066 0l4.188 4.188L9.197.247l1.063 1.057L6.315 5.25l3.945 3.945-1.062 1.057-3.943-3.941-4.187 4.188z"
  })));
};

export default SvgClose;